// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum PossibleExemptionRegistrationMethod {
  Notification = "NOTIFICATION",
  AutomaticallyByLicensePlateFormat = "AUTOMATICALLY_BY_LICENSE_PLATE_FORMAT",
  VehicleRegisterSynchronization = "VEHICLE_REGISTER_SYNCHRONIZATION",
}
export default PossibleExemptionRegistrationMethod;
